import * as yup from "yup";

const schema = yup.object().shape({
  displayName: yup
    .string()
    .min(3, "Minimum 3 characters")
    .max(255, "Maximum 255 characters")
    .required("Name is required"),
});

export default schema;
